import { default as index8Gx4QWPmzWMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue?macro=true";
import { default as resultsZVsCgaHXrGMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue?macro=true";
import { default as indexStORcu6ed1Meta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue?macro=true";
import { default as none1R8YzK1rQJMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue?macro=true";
import { default as profilesSLpmZe7pTMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue?macro=true";
import { default as imagerp18uEzdJ2Meta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue?macro=true";
import { default as index5y5I6ziDwHMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue?macro=true";
import { default as aggregate0aOgL9cnpwMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue?macro=true";
import { default as indexSnjeHuSZ0DMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue?macro=true";
import { default as profileWmkgwBegoeMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue?macro=true";
import { default as resultsSxTMUZKl7HMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue?macro=true";
import { default as _91roundId_93JQWyrDPbOCMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue?macro=true";
import { default as createH4vSDrHLUAMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue?macro=true";
import { default as _91userId_93mE9f9J9D9vMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue?macro=true";
import { default as indexkKM9RZyGauMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue?macro=true";
import { default as createL29BopCCi8Meta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue?macro=true";
import { default as indexmj1TxhbuXRMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue?macro=true";
import { default as loginQW7Z8JjAEzMeta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue?macro=true";
import { default as registermqmnk7XXD7Meta } from "/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue?macro=true";
export default [
  {
    name: index8Gx4QWPmzWMeta?.name ?? "projectId-roundId___en",
    path: index8Gx4QWPmzWMeta?.path ?? "/:projectId()/:roundId()",
    meta: index8Gx4QWPmzWMeta || {},
    alias: index8Gx4QWPmzWMeta?.alias || [],
    redirect: index8Gx4QWPmzWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gx4QWPmzWMeta?.name ?? "projectId-roundId___nl",
    path: index8Gx4QWPmzWMeta?.path ?? "/nl/:projectId()/:roundId()",
    meta: index8Gx4QWPmzWMeta || {},
    alias: index8Gx4QWPmzWMeta?.alias || [],
    redirect: index8Gx4QWPmzWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gx4QWPmzWMeta?.name ?? "projectId-roundId___de",
    path: index8Gx4QWPmzWMeta?.path ?? "/de/:projectId()/:roundId()",
    meta: index8Gx4QWPmzWMeta || {},
    alias: index8Gx4QWPmzWMeta?.alias || [],
    redirect: index8Gx4QWPmzWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gx4QWPmzWMeta?.name ?? "projectId-roundId___es",
    path: index8Gx4QWPmzWMeta?.path ?? "/es/:projectId()/:roundId()",
    meta: index8Gx4QWPmzWMeta || {},
    alias: index8Gx4QWPmzWMeta?.alias || [],
    redirect: index8Gx4QWPmzWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gx4QWPmzWMeta?.name ?? "projectId-roundId___fr",
    path: index8Gx4QWPmzWMeta?.path ?? "/fr/:projectId()/:roundId()",
    meta: index8Gx4QWPmzWMeta || {},
    alias: index8Gx4QWPmzWMeta?.alias || [],
    redirect: index8Gx4QWPmzWMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/index.vue").then(m => m.default || m)
  },
  {
    name: resultsZVsCgaHXrGMeta?.name ?? "projectId-roundId-results___en",
    path: resultsZVsCgaHXrGMeta?.path ?? "/:projectId()/:roundId()/results",
    meta: resultsZVsCgaHXrGMeta || {},
    alias: resultsZVsCgaHXrGMeta?.alias || [],
    redirect: resultsZVsCgaHXrGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsZVsCgaHXrGMeta?.name ?? "projectId-roundId-results___nl",
    path: resultsZVsCgaHXrGMeta?.path ?? "/nl/:projectId()/:roundId()/results",
    meta: resultsZVsCgaHXrGMeta || {},
    alias: resultsZVsCgaHXrGMeta?.alias || [],
    redirect: resultsZVsCgaHXrGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsZVsCgaHXrGMeta?.name ?? "projectId-roundId-results___de",
    path: resultsZVsCgaHXrGMeta?.path ?? "/de/:projectId()/:roundId()/results",
    meta: resultsZVsCgaHXrGMeta || {},
    alias: resultsZVsCgaHXrGMeta?.alias || [],
    redirect: resultsZVsCgaHXrGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsZVsCgaHXrGMeta?.name ?? "projectId-roundId-results___es",
    path: resultsZVsCgaHXrGMeta?.path ?? "/es/:projectId()/:roundId()/results",
    meta: resultsZVsCgaHXrGMeta || {},
    alias: resultsZVsCgaHXrGMeta?.alias || [],
    redirect: resultsZVsCgaHXrGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsZVsCgaHXrGMeta?.name ?? "projectId-roundId-results___fr",
    path: resultsZVsCgaHXrGMeta?.path ?? "/fr/:projectId()/:roundId()/results",
    meta: resultsZVsCgaHXrGMeta || {},
    alias: resultsZVsCgaHXrGMeta?.alias || [],
    redirect: resultsZVsCgaHXrGMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/[roundId]/results.vue").then(m => m.default || m)
  },
  {
    name: indexStORcu6ed1Meta?.name ?? "projectId___en",
    path: indexStORcu6ed1Meta?.path ?? "/:projectId()",
    meta: indexStORcu6ed1Meta || {},
    alias: indexStORcu6ed1Meta?.alias || [],
    redirect: indexStORcu6ed1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexStORcu6ed1Meta?.name ?? "projectId___nl",
    path: indexStORcu6ed1Meta?.path ?? "/nl/:projectId()",
    meta: indexStORcu6ed1Meta || {},
    alias: indexStORcu6ed1Meta?.alias || [],
    redirect: indexStORcu6ed1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexStORcu6ed1Meta?.name ?? "projectId___de",
    path: indexStORcu6ed1Meta?.path ?? "/de/:projectId()",
    meta: indexStORcu6ed1Meta || {},
    alias: indexStORcu6ed1Meta?.alias || [],
    redirect: indexStORcu6ed1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexStORcu6ed1Meta?.name ?? "projectId___es",
    path: indexStORcu6ed1Meta?.path ?? "/es/:projectId()",
    meta: indexStORcu6ed1Meta || {},
    alias: indexStORcu6ed1Meta?.alias || [],
    redirect: indexStORcu6ed1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexStORcu6ed1Meta?.name ?? "projectId___fr",
    path: indexStORcu6ed1Meta?.path ?? "/fr/:projectId()",
    meta: indexStORcu6ed1Meta || {},
    alias: indexStORcu6ed1Meta?.alias || [],
    redirect: indexStORcu6ed1Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: none1R8YzK1rQJMeta?.name ?? "projectId-none___en",
    path: none1R8YzK1rQJMeta?.path ?? "/:projectId()/none",
    meta: none1R8YzK1rQJMeta || {},
    alias: none1R8YzK1rQJMeta?.alias || [],
    redirect: none1R8YzK1rQJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: none1R8YzK1rQJMeta?.name ?? "projectId-none___nl",
    path: none1R8YzK1rQJMeta?.path ?? "/nl/:projectId()/none",
    meta: none1R8YzK1rQJMeta || {},
    alias: none1R8YzK1rQJMeta?.alias || [],
    redirect: none1R8YzK1rQJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: none1R8YzK1rQJMeta?.name ?? "projectId-none___de",
    path: none1R8YzK1rQJMeta?.path ?? "/de/:projectId()/none",
    meta: none1R8YzK1rQJMeta || {},
    alias: none1R8YzK1rQJMeta?.alias || [],
    redirect: none1R8YzK1rQJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: none1R8YzK1rQJMeta?.name ?? "projectId-none___es",
    path: none1R8YzK1rQJMeta?.path ?? "/es/:projectId()/none",
    meta: none1R8YzK1rQJMeta || {},
    alias: none1R8YzK1rQJMeta?.alias || [],
    redirect: none1R8YzK1rQJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: none1R8YzK1rQJMeta?.name ?? "projectId-none___fr",
    path: none1R8YzK1rQJMeta?.path ?? "/fr/:projectId()/none",
    meta: none1R8YzK1rQJMeta || {},
    alias: none1R8YzK1rQJMeta?.alias || [],
    redirect: none1R8YzK1rQJMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/none.vue").then(m => m.default || m)
  },
  {
    name: profilesSLpmZe7pTMeta?.name ?? "projectId-profile___en",
    path: profilesSLpmZe7pTMeta?.path ?? "/:projectId()/profile",
    meta: profilesSLpmZe7pTMeta || {},
    alias: profilesSLpmZe7pTMeta?.alias || [],
    redirect: profilesSLpmZe7pTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilesSLpmZe7pTMeta?.name ?? "projectId-profile___nl",
    path: profilesSLpmZe7pTMeta?.path ?? "/nl/:projectId()/profile",
    meta: profilesSLpmZe7pTMeta || {},
    alias: profilesSLpmZe7pTMeta?.alias || [],
    redirect: profilesSLpmZe7pTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilesSLpmZe7pTMeta?.name ?? "projectId-profile___de",
    path: profilesSLpmZe7pTMeta?.path ?? "/de/:projectId()/profile",
    meta: profilesSLpmZe7pTMeta || {},
    alias: profilesSLpmZe7pTMeta?.alias || [],
    redirect: profilesSLpmZe7pTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilesSLpmZe7pTMeta?.name ?? "projectId-profile___es",
    path: profilesSLpmZe7pTMeta?.path ?? "/es/:projectId()/profile",
    meta: profilesSLpmZe7pTMeta || {},
    alias: profilesSLpmZe7pTMeta?.alias || [],
    redirect: profilesSLpmZe7pTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profilesSLpmZe7pTMeta?.name ?? "projectId-profile___fr",
    path: profilesSLpmZe7pTMeta?.path ?? "/fr/:projectId()/profile",
    meta: profilesSLpmZe7pTMeta || {},
    alias: profilesSLpmZe7pTMeta?.alias || [],
    redirect: profilesSLpmZe7pTMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: imagerp18uEzdJ2Meta?.name ?? "admin-answer-answerId-image___en",
    path: imagerp18uEzdJ2Meta?.path ?? "/admin/answer/:answerId()/image",
    meta: imagerp18uEzdJ2Meta || {},
    alias: imagerp18uEzdJ2Meta?.alias || [],
    redirect: imagerp18uEzdJ2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerp18uEzdJ2Meta?.name ?? "admin-answer-answerId-image___nl",
    path: imagerp18uEzdJ2Meta?.path ?? "/nl/admin/answer/:answerId()/image",
    meta: imagerp18uEzdJ2Meta || {},
    alias: imagerp18uEzdJ2Meta?.alias || [],
    redirect: imagerp18uEzdJ2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerp18uEzdJ2Meta?.name ?? "admin-answer-answerId-image___de",
    path: imagerp18uEzdJ2Meta?.path ?? "/de/admin/answer/:answerId()/image",
    meta: imagerp18uEzdJ2Meta || {},
    alias: imagerp18uEzdJ2Meta?.alias || [],
    redirect: imagerp18uEzdJ2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerp18uEzdJ2Meta?.name ?? "admin-answer-answerId-image___es",
    path: imagerp18uEzdJ2Meta?.path ?? "/es/admin/answer/:answerId()/image",
    meta: imagerp18uEzdJ2Meta || {},
    alias: imagerp18uEzdJ2Meta?.alias || [],
    redirect: imagerp18uEzdJ2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: imagerp18uEzdJ2Meta?.name ?? "admin-answer-answerId-image___fr",
    path: imagerp18uEzdJ2Meta?.path ?? "/fr/admin/answer/:answerId()/image",
    meta: imagerp18uEzdJ2Meta || {},
    alias: imagerp18uEzdJ2Meta?.alias || [],
    redirect: imagerp18uEzdJ2Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/answer/[answerId]/image.vue").then(m => m.default || m)
  },
  {
    name: index5y5I6ziDwHMeta?.name ?? "admin___en",
    path: index5y5I6ziDwHMeta?.path ?? "/admin",
    meta: index5y5I6ziDwHMeta || {},
    alias: index5y5I6ziDwHMeta?.alias || [],
    redirect: index5y5I6ziDwHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: index5y5I6ziDwHMeta?.name ?? "admin___nl",
    path: index5y5I6ziDwHMeta?.path ?? "/nl/admin",
    meta: index5y5I6ziDwHMeta || {},
    alias: index5y5I6ziDwHMeta?.alias || [],
    redirect: index5y5I6ziDwHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: index5y5I6ziDwHMeta?.name ?? "admin___de",
    path: index5y5I6ziDwHMeta?.path ?? "/de/admin",
    meta: index5y5I6ziDwHMeta || {},
    alias: index5y5I6ziDwHMeta?.alias || [],
    redirect: index5y5I6ziDwHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: index5y5I6ziDwHMeta?.name ?? "admin___es",
    path: index5y5I6ziDwHMeta?.path ?? "/es/admin",
    meta: index5y5I6ziDwHMeta || {},
    alias: index5y5I6ziDwHMeta?.alias || [],
    redirect: index5y5I6ziDwHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: index5y5I6ziDwHMeta?.name ?? "admin___fr",
    path: index5y5I6ziDwHMeta?.path ?? "/fr/admin",
    meta: index5y5I6ziDwHMeta || {},
    alias: index5y5I6ziDwHMeta?.alias || [],
    redirect: index5y5I6ziDwHMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: aggregate0aOgL9cnpwMeta?.name ?? "admin-project-projectId-aggregate___en",
    path: aggregate0aOgL9cnpwMeta?.path ?? "/admin/project/:projectId()/aggregate",
    meta: aggregate0aOgL9cnpwMeta || {},
    alias: aggregate0aOgL9cnpwMeta?.alias || [],
    redirect: aggregate0aOgL9cnpwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregate0aOgL9cnpwMeta?.name ?? "admin-project-projectId-aggregate___nl",
    path: aggregate0aOgL9cnpwMeta?.path ?? "/nl/admin/project/:projectId()/aggregate",
    meta: aggregate0aOgL9cnpwMeta || {},
    alias: aggregate0aOgL9cnpwMeta?.alias || [],
    redirect: aggregate0aOgL9cnpwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregate0aOgL9cnpwMeta?.name ?? "admin-project-projectId-aggregate___de",
    path: aggregate0aOgL9cnpwMeta?.path ?? "/de/admin/project/:projectId()/aggregate",
    meta: aggregate0aOgL9cnpwMeta || {},
    alias: aggregate0aOgL9cnpwMeta?.alias || [],
    redirect: aggregate0aOgL9cnpwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregate0aOgL9cnpwMeta?.name ?? "admin-project-projectId-aggregate___es",
    path: aggregate0aOgL9cnpwMeta?.path ?? "/es/admin/project/:projectId()/aggregate",
    meta: aggregate0aOgL9cnpwMeta || {},
    alias: aggregate0aOgL9cnpwMeta?.alias || [],
    redirect: aggregate0aOgL9cnpwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: aggregate0aOgL9cnpwMeta?.name ?? "admin-project-projectId-aggregate___fr",
    path: aggregate0aOgL9cnpwMeta?.path ?? "/fr/admin/project/:projectId()/aggregate",
    meta: aggregate0aOgL9cnpwMeta || {},
    alias: aggregate0aOgL9cnpwMeta?.alias || [],
    redirect: aggregate0aOgL9cnpwMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/aggregate.vue").then(m => m.default || m)
  },
  {
    name: indexSnjeHuSZ0DMeta?.name ?? "admin-project-projectId___en",
    path: indexSnjeHuSZ0DMeta?.path ?? "/admin/project/:projectId()",
    meta: indexSnjeHuSZ0DMeta || {},
    alias: indexSnjeHuSZ0DMeta?.alias || [],
    redirect: indexSnjeHuSZ0DMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSnjeHuSZ0DMeta?.name ?? "admin-project-projectId___nl",
    path: indexSnjeHuSZ0DMeta?.path ?? "/nl/admin/project/:projectId()",
    meta: indexSnjeHuSZ0DMeta || {},
    alias: indexSnjeHuSZ0DMeta?.alias || [],
    redirect: indexSnjeHuSZ0DMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSnjeHuSZ0DMeta?.name ?? "admin-project-projectId___de",
    path: indexSnjeHuSZ0DMeta?.path ?? "/de/admin/project/:projectId()",
    meta: indexSnjeHuSZ0DMeta || {},
    alias: indexSnjeHuSZ0DMeta?.alias || [],
    redirect: indexSnjeHuSZ0DMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSnjeHuSZ0DMeta?.name ?? "admin-project-projectId___es",
    path: indexSnjeHuSZ0DMeta?.path ?? "/es/admin/project/:projectId()",
    meta: indexSnjeHuSZ0DMeta || {},
    alias: indexSnjeHuSZ0DMeta?.alias || [],
    redirect: indexSnjeHuSZ0DMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSnjeHuSZ0DMeta?.name ?? "admin-project-projectId___fr",
    path: indexSnjeHuSZ0DMeta?.path ?? "/fr/admin/project/:projectId()",
    meta: indexSnjeHuSZ0DMeta || {},
    alias: indexSnjeHuSZ0DMeta?.alias || [],
    redirect: indexSnjeHuSZ0DMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: profileWmkgwBegoeMeta?.name ?? "admin-project-projectId-profile___en",
    path: profileWmkgwBegoeMeta?.path ?? "/admin/project/:projectId()/profile",
    meta: profileWmkgwBegoeMeta || {},
    alias: profileWmkgwBegoeMeta?.alias || [],
    redirect: profileWmkgwBegoeMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileWmkgwBegoeMeta?.name ?? "admin-project-projectId-profile___nl",
    path: profileWmkgwBegoeMeta?.path ?? "/nl/admin/project/:projectId()/profile",
    meta: profileWmkgwBegoeMeta || {},
    alias: profileWmkgwBegoeMeta?.alias || [],
    redirect: profileWmkgwBegoeMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileWmkgwBegoeMeta?.name ?? "admin-project-projectId-profile___de",
    path: profileWmkgwBegoeMeta?.path ?? "/de/admin/project/:projectId()/profile",
    meta: profileWmkgwBegoeMeta || {},
    alias: profileWmkgwBegoeMeta?.alias || [],
    redirect: profileWmkgwBegoeMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileWmkgwBegoeMeta?.name ?? "admin-project-projectId-profile___es",
    path: profileWmkgwBegoeMeta?.path ?? "/es/admin/project/:projectId()/profile",
    meta: profileWmkgwBegoeMeta || {},
    alias: profileWmkgwBegoeMeta?.alias || [],
    redirect: profileWmkgwBegoeMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: profileWmkgwBegoeMeta?.name ?? "admin-project-projectId-profile___fr",
    path: profileWmkgwBegoeMeta?.path ?? "/fr/admin/project/:projectId()/profile",
    meta: profileWmkgwBegoeMeta || {},
    alias: profileWmkgwBegoeMeta?.alias || [],
    redirect: profileWmkgwBegoeMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/profile.vue").then(m => m.default || m)
  },
  {
    name: resultsSxTMUZKl7HMeta?.name ?? "admin-project-projectId-results___en",
    path: resultsSxTMUZKl7HMeta?.path ?? "/admin/project/:projectId()/results",
    meta: resultsSxTMUZKl7HMeta || {},
    alias: resultsSxTMUZKl7HMeta?.alias || [],
    redirect: resultsSxTMUZKl7HMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsSxTMUZKl7HMeta?.name ?? "admin-project-projectId-results___nl",
    path: resultsSxTMUZKl7HMeta?.path ?? "/nl/admin/project/:projectId()/results",
    meta: resultsSxTMUZKl7HMeta || {},
    alias: resultsSxTMUZKl7HMeta?.alias || [],
    redirect: resultsSxTMUZKl7HMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsSxTMUZKl7HMeta?.name ?? "admin-project-projectId-results___de",
    path: resultsSxTMUZKl7HMeta?.path ?? "/de/admin/project/:projectId()/results",
    meta: resultsSxTMUZKl7HMeta || {},
    alias: resultsSxTMUZKl7HMeta?.alias || [],
    redirect: resultsSxTMUZKl7HMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsSxTMUZKl7HMeta?.name ?? "admin-project-projectId-results___es",
    path: resultsSxTMUZKl7HMeta?.path ?? "/es/admin/project/:projectId()/results",
    meta: resultsSxTMUZKl7HMeta || {},
    alias: resultsSxTMUZKl7HMeta?.alias || [],
    redirect: resultsSxTMUZKl7HMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: resultsSxTMUZKl7HMeta?.name ?? "admin-project-projectId-results___fr",
    path: resultsSxTMUZKl7HMeta?.path ?? "/fr/admin/project/:projectId()/results",
    meta: resultsSxTMUZKl7HMeta || {},
    alias: resultsSxTMUZKl7HMeta?.alias || [],
    redirect: resultsSxTMUZKl7HMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/results.vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93JQWyrDPbOCMeta?.name ?? "admin-project-projectId-round-roundId___en",
    path: _91roundId_93JQWyrDPbOCMeta?.path ?? "/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93JQWyrDPbOCMeta || {},
    alias: _91roundId_93JQWyrDPbOCMeta?.alias || [],
    redirect: _91roundId_93JQWyrDPbOCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93JQWyrDPbOCMeta?.name ?? "admin-project-projectId-round-roundId___nl",
    path: _91roundId_93JQWyrDPbOCMeta?.path ?? "/nl/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93JQWyrDPbOCMeta || {},
    alias: _91roundId_93JQWyrDPbOCMeta?.alias || [],
    redirect: _91roundId_93JQWyrDPbOCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93JQWyrDPbOCMeta?.name ?? "admin-project-projectId-round-roundId___de",
    path: _91roundId_93JQWyrDPbOCMeta?.path ?? "/de/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93JQWyrDPbOCMeta || {},
    alias: _91roundId_93JQWyrDPbOCMeta?.alias || [],
    redirect: _91roundId_93JQWyrDPbOCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93JQWyrDPbOCMeta?.name ?? "admin-project-projectId-round-roundId___es",
    path: _91roundId_93JQWyrDPbOCMeta?.path ?? "/es/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93JQWyrDPbOCMeta || {},
    alias: _91roundId_93JQWyrDPbOCMeta?.alias || [],
    redirect: _91roundId_93JQWyrDPbOCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: _91roundId_93JQWyrDPbOCMeta?.name ?? "admin-project-projectId-round-roundId___fr",
    path: _91roundId_93JQWyrDPbOCMeta?.path ?? "/fr/admin/project/:projectId()/round/:roundId()",
    meta: _91roundId_93JQWyrDPbOCMeta || {},
    alias: _91roundId_93JQWyrDPbOCMeta?.alias || [],
    redirect: _91roundId_93JQWyrDPbOCMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/[roundId].vue").then(m => m.default || m)
  },
  {
    name: createH4vSDrHLUAMeta?.name ?? "admin-project-projectId-round-create___en",
    path: createH4vSDrHLUAMeta?.path ?? "/admin/project/:projectId()/round/create",
    meta: createH4vSDrHLUAMeta || {},
    alias: createH4vSDrHLUAMeta?.alias || [],
    redirect: createH4vSDrHLUAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createH4vSDrHLUAMeta?.name ?? "admin-project-projectId-round-create___nl",
    path: createH4vSDrHLUAMeta?.path ?? "/nl/admin/project/:projectId()/round/create",
    meta: createH4vSDrHLUAMeta || {},
    alias: createH4vSDrHLUAMeta?.alias || [],
    redirect: createH4vSDrHLUAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createH4vSDrHLUAMeta?.name ?? "admin-project-projectId-round-create___de",
    path: createH4vSDrHLUAMeta?.path ?? "/de/admin/project/:projectId()/round/create",
    meta: createH4vSDrHLUAMeta || {},
    alias: createH4vSDrHLUAMeta?.alias || [],
    redirect: createH4vSDrHLUAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createH4vSDrHLUAMeta?.name ?? "admin-project-projectId-round-create___es",
    path: createH4vSDrHLUAMeta?.path ?? "/es/admin/project/:projectId()/round/create",
    meta: createH4vSDrHLUAMeta || {},
    alias: createH4vSDrHLUAMeta?.alias || [],
    redirect: createH4vSDrHLUAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: createH4vSDrHLUAMeta?.name ?? "admin-project-projectId-round-create___fr",
    path: createH4vSDrHLUAMeta?.path ?? "/fr/admin/project/:projectId()/round/create",
    meta: createH4vSDrHLUAMeta || {},
    alias: createH4vSDrHLUAMeta?.alias || [],
    redirect: createH4vSDrHLUAMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/round/create.vue").then(m => m.default || m)
  },
  {
    name: _91userId_93mE9f9J9D9vMeta?.name ?? "admin-project-projectId-users-userId___en",
    path: _91userId_93mE9f9J9D9vMeta?.path ?? "/admin/project/:projectId()/users/:userId()",
    meta: _91userId_93mE9f9J9D9vMeta || {},
    alias: _91userId_93mE9f9J9D9vMeta?.alias || [],
    redirect: _91userId_93mE9f9J9D9vMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_93mE9f9J9D9vMeta?.name ?? "admin-project-projectId-users-userId___nl",
    path: _91userId_93mE9f9J9D9vMeta?.path ?? "/nl/admin/project/:projectId()/users/:userId()",
    meta: _91userId_93mE9f9J9D9vMeta || {},
    alias: _91userId_93mE9f9J9D9vMeta?.alias || [],
    redirect: _91userId_93mE9f9J9D9vMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_93mE9f9J9D9vMeta?.name ?? "admin-project-projectId-users-userId___de",
    path: _91userId_93mE9f9J9D9vMeta?.path ?? "/de/admin/project/:projectId()/users/:userId()",
    meta: _91userId_93mE9f9J9D9vMeta || {},
    alias: _91userId_93mE9f9J9D9vMeta?.alias || [],
    redirect: _91userId_93mE9f9J9D9vMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_93mE9f9J9D9vMeta?.name ?? "admin-project-projectId-users-userId___es",
    path: _91userId_93mE9f9J9D9vMeta?.path ?? "/es/admin/project/:projectId()/users/:userId()",
    meta: _91userId_93mE9f9J9D9vMeta || {},
    alias: _91userId_93mE9f9J9D9vMeta?.alias || [],
    redirect: _91userId_93mE9f9J9D9vMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: _91userId_93mE9f9J9D9vMeta?.name ?? "admin-project-projectId-users-userId___fr",
    path: _91userId_93mE9f9J9D9vMeta?.path ?? "/fr/admin/project/:projectId()/users/:userId()",
    meta: _91userId_93mE9f9J9D9vMeta || {},
    alias: _91userId_93mE9f9J9D9vMeta?.alias || [],
    redirect: _91userId_93mE9f9J9D9vMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/[userId].vue").then(m => m.default || m)
  },
  {
    name: indexkKM9RZyGauMeta?.name ?? "admin-project-projectId-users___en",
    path: indexkKM9RZyGauMeta?.path ?? "/admin/project/:projectId()/users",
    meta: indexkKM9RZyGauMeta || {},
    alias: indexkKM9RZyGauMeta?.alias || [],
    redirect: indexkKM9RZyGauMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexkKM9RZyGauMeta?.name ?? "admin-project-projectId-users___nl",
    path: indexkKM9RZyGauMeta?.path ?? "/nl/admin/project/:projectId()/users",
    meta: indexkKM9RZyGauMeta || {},
    alias: indexkKM9RZyGauMeta?.alias || [],
    redirect: indexkKM9RZyGauMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexkKM9RZyGauMeta?.name ?? "admin-project-projectId-users___de",
    path: indexkKM9RZyGauMeta?.path ?? "/de/admin/project/:projectId()/users",
    meta: indexkKM9RZyGauMeta || {},
    alias: indexkKM9RZyGauMeta?.alias || [],
    redirect: indexkKM9RZyGauMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexkKM9RZyGauMeta?.name ?? "admin-project-projectId-users___es",
    path: indexkKM9RZyGauMeta?.path ?? "/es/admin/project/:projectId()/users",
    meta: indexkKM9RZyGauMeta || {},
    alias: indexkKM9RZyGauMeta?.alias || [],
    redirect: indexkKM9RZyGauMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: indexkKM9RZyGauMeta?.name ?? "admin-project-projectId-users___fr",
    path: indexkKM9RZyGauMeta?.path ?? "/fr/admin/project/:projectId()/users",
    meta: indexkKM9RZyGauMeta || {},
    alias: indexkKM9RZyGauMeta?.alias || [],
    redirect: indexkKM9RZyGauMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/[projectId]/users/index.vue").then(m => m.default || m)
  },
  {
    name: createL29BopCCi8Meta?.name ?? "admin-project-create___en",
    path: createL29BopCCi8Meta?.path ?? "/admin/project/create",
    meta: createL29BopCCi8Meta || {},
    alias: createL29BopCCi8Meta?.alias || [],
    redirect: createL29BopCCi8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createL29BopCCi8Meta?.name ?? "admin-project-create___nl",
    path: createL29BopCCi8Meta?.path ?? "/nl/admin/project/create",
    meta: createL29BopCCi8Meta || {},
    alias: createL29BopCCi8Meta?.alias || [],
    redirect: createL29BopCCi8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createL29BopCCi8Meta?.name ?? "admin-project-create___de",
    path: createL29BopCCi8Meta?.path ?? "/de/admin/project/create",
    meta: createL29BopCCi8Meta || {},
    alias: createL29BopCCi8Meta?.alias || [],
    redirect: createL29BopCCi8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createL29BopCCi8Meta?.name ?? "admin-project-create___es",
    path: createL29BopCCi8Meta?.path ?? "/es/admin/project/create",
    meta: createL29BopCCi8Meta || {},
    alias: createL29BopCCi8Meta?.alias || [],
    redirect: createL29BopCCi8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: createL29BopCCi8Meta?.name ?? "admin-project-create___fr",
    path: createL29BopCCi8Meta?.path ?? "/fr/admin/project/create",
    meta: createL29BopCCi8Meta || {},
    alias: createL29BopCCi8Meta?.alias || [],
    redirect: createL29BopCCi8Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/admin/project/create.vue").then(m => m.default || m)
  },
  {
    name: indexmj1TxhbuXRMeta?.name ?? "index___en",
    path: indexmj1TxhbuXRMeta?.path ?? "/",
    meta: indexmj1TxhbuXRMeta || {},
    alias: indexmj1TxhbuXRMeta?.alias || [],
    redirect: indexmj1TxhbuXRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexmj1TxhbuXRMeta?.name ?? "index___nl",
    path: indexmj1TxhbuXRMeta?.path ?? "/nl",
    meta: indexmj1TxhbuXRMeta || {},
    alias: indexmj1TxhbuXRMeta?.alias || [],
    redirect: indexmj1TxhbuXRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexmj1TxhbuXRMeta?.name ?? "index___de",
    path: indexmj1TxhbuXRMeta?.path ?? "/de",
    meta: indexmj1TxhbuXRMeta || {},
    alias: indexmj1TxhbuXRMeta?.alias || [],
    redirect: indexmj1TxhbuXRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexmj1TxhbuXRMeta?.name ?? "index___es",
    path: indexmj1TxhbuXRMeta?.path ?? "/es",
    meta: indexmj1TxhbuXRMeta || {},
    alias: indexmj1TxhbuXRMeta?.alias || [],
    redirect: indexmj1TxhbuXRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexmj1TxhbuXRMeta?.name ?? "index___fr",
    path: indexmj1TxhbuXRMeta?.path ?? "/fr",
    meta: indexmj1TxhbuXRMeta || {},
    alias: indexmj1TxhbuXRMeta?.alias || [],
    redirect: indexmj1TxhbuXRMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginQW7Z8JjAEzMeta?.name ?? "login___en",
    path: loginQW7Z8JjAEzMeta?.path ?? "/login",
    meta: loginQW7Z8JjAEzMeta || {},
    alias: loginQW7Z8JjAEzMeta?.alias || [],
    redirect: loginQW7Z8JjAEzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQW7Z8JjAEzMeta?.name ?? "login___nl",
    path: loginQW7Z8JjAEzMeta?.path ?? "/nl/login",
    meta: loginQW7Z8JjAEzMeta || {},
    alias: loginQW7Z8JjAEzMeta?.alias || [],
    redirect: loginQW7Z8JjAEzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQW7Z8JjAEzMeta?.name ?? "login___de",
    path: loginQW7Z8JjAEzMeta?.path ?? "/de/login",
    meta: loginQW7Z8JjAEzMeta || {},
    alias: loginQW7Z8JjAEzMeta?.alias || [],
    redirect: loginQW7Z8JjAEzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQW7Z8JjAEzMeta?.name ?? "login___es",
    path: loginQW7Z8JjAEzMeta?.path ?? "/es/login",
    meta: loginQW7Z8JjAEzMeta || {},
    alias: loginQW7Z8JjAEzMeta?.alias || [],
    redirect: loginQW7Z8JjAEzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQW7Z8JjAEzMeta?.name ?? "login___fr",
    path: loginQW7Z8JjAEzMeta?.path ?? "/fr/login",
    meta: loginQW7Z8JjAEzMeta || {},
    alias: loginQW7Z8JjAEzMeta?.alias || [],
    redirect: loginQW7Z8JjAEzMeta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: registermqmnk7XXD7Meta?.name ?? "register___en",
    path: registermqmnk7XXD7Meta?.path ?? "/register",
    meta: registermqmnk7XXD7Meta || {},
    alias: registermqmnk7XXD7Meta?.alias || [],
    redirect: registermqmnk7XXD7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registermqmnk7XXD7Meta?.name ?? "register___nl",
    path: registermqmnk7XXD7Meta?.path ?? "/nl/register",
    meta: registermqmnk7XXD7Meta || {},
    alias: registermqmnk7XXD7Meta?.alias || [],
    redirect: registermqmnk7XXD7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registermqmnk7XXD7Meta?.name ?? "register___de",
    path: registermqmnk7XXD7Meta?.path ?? "/de/register",
    meta: registermqmnk7XXD7Meta || {},
    alias: registermqmnk7XXD7Meta?.alias || [],
    redirect: registermqmnk7XXD7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registermqmnk7XXD7Meta?.name ?? "register___es",
    path: registermqmnk7XXD7Meta?.path ?? "/es/register",
    meta: registermqmnk7XXD7Meta || {},
    alias: registermqmnk7XXD7Meta?.alias || [],
    redirect: registermqmnk7XXD7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registermqmnk7XXD7Meta?.name ?? "register___fr",
    path: registermqmnk7XXD7Meta?.path ?? "/fr/register",
    meta: registermqmnk7XXD7Meta || {},
    alias: registermqmnk7XXD7Meta?.alias || [],
    redirect: registermqmnk7XXD7Meta?.redirect || undefined,
    component: () => import("/codebuild/output/src4219241025/src/sense-us.app/pages/register.vue").then(m => m.default || m)
  }
]